export default __webpack_public_path__ + "static/media/urban_sports_club.603bfda9.svg";